import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LeadService } from 'src/app/services/lead.service';
import { SaveTfnRequestAction, SaveTfnResponseAction } from './actions';
import { ErrorUpdatingAction } from '../../actions';

@Injectable()
export class NmjTfnEffects {
    constructor(
        private actions$: Actions,
        private service: LeadService) {
    }

    updateNextPage$ = createEffect(() => this.actions$.pipe(
        ofType(SaveTfnRequestAction),
        switchMap((action: any) => this.service.update(action.step, action.field, action.data).pipe(
            map((data: any) => {
                this.service.showOk(data.message);
                return SaveTfnResponseAction();
            }),
            catchError(_err => {
                return of(ErrorUpdatingAction());
            })
        )),
    ));
}
